<template>
    <inertia-head title="Log in"/>

    <jet-authentication-card>
        <template #logo>
            <div class="h-32 md:h-auto md:w-1/2">
                <jet-authentication-card-logo/>
            </div>
        </template>

        <div class="w-full">
            <jet-validation-errors class="mb-4"/>

            <div v-if="status" class="mb-4 font-medium text-sm text-green-600">
                {{ status }}
            </div>

            <h1
                class="mb-4 text-xl font-semibold text-gray-700 dark:text-gray-400"
            >
                Login
            </h1>
            <form @submit.prevent="submit">
                <label class="block text-sm">
                    <span class="text-gray-700 dark:text-gray-400">Email</span>
                    <jet-input
                        type="email"
                        name="email"
                        class="block w-full"
                        placeholder="email@example.com"
                        v-model="form.email"
                        required
                        autofocus
                    />
                </label>
                <label class="block mt-4 text-sm">
                    <span class="text-gray-700 dark:text-gray-400">Password</span>
                    <jet-input
                        type="password"
                        name="password"
                        class="block w-full"
                        placeholder="***************"
                        v-model="form.password"
                        required
                        autocomplete="current-password"
                    />
                </label>

                <label class="flex items-center mt-4 text-sm">
                    <jet-checkbox name="remember" v-model:checked="form.remember"/>
                    <span class="ml-2 text-sm text-gray-600 dark:text-gray-400">Remember me</span>
                </label>
                <jet-button class="block w-full mt-4">
                    Log in
                </jet-button>

                <hr class="my-8"/>

                <p class="mt-4">
                    <inertia-link v-if="canResetPassword"
                       :href="route('password.request')"
                       class="text-sm font-medium text-purple-600 dark:text-purple-400 hover:underline"
                    >
                        Forgot your password?
                    </inertia-link>
                </p>
                <p class="mt-4">
                    <inertia-link :href="route('register')"
                                  class="text-sm font-medium text-purple-600 dark:text-purple-400 hover:underline"
                    >
                        Don't have an account? Register here!
                    </inertia-link>
                </p>
            </form>
        </div>
    </jet-authentication-card>
</template>

<script>
import {defineComponent} from 'vue';
import JetAuthenticationCard from '@/Jetstream/AuthenticationCard.vue';
import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo.vue';
import JetCheckbox from '@/Jetstream/Checkbox.vue';
import JetValidationErrors from '@/Jetstream/ValidationErrors.vue';
import JetInput from '@/Jetstream/Input.vue';
import JetButton from '@/Jetstream/Button.vue';

export default defineComponent({
    components: {
        JetAuthenticationCard,
        JetAuthenticationCardLogo,
        JetValidationErrors,
        JetCheckbox,
        JetInput,
        JetButton,
    },
    props: {
        canResetPassword: Boolean,
        status: String,
    },
    data() {
        return {
            form: this.$inertia.form({
                email: '',
                password: '',
                remember: false
            })
        }
    },
    methods: {
        submit() {
            this.form
                .transform(data => ({
                    ...data,
                    remember: this.form.remember ? 'on' : ''
                }))
                .post(this.route('login'), {
                    onFinish: () => this.form.reset('password'),
                })
        }
    }
})
</script>
